import Model from './BaseModel'

import Permission from './Permission'

export default class Role extends Model {
    resourceName() {
        return 'roles'
    }

    fields() {
        return ['id', 'name', 'hidden', 'account_manager']
    }

    relationships() {
        return {
            permissions: new Permission(),
        }
    }
}
